import { ArrowUp } from "lucide-react";
import { FIRM } from "../../content";

export const Footer = ({ t, go }) => (
  <footer data-testid="site-footer" className="bg-[#0B1828] text-slate-300">
    <div className="mx-auto max-w-7xl px-6 pt-20 pb-10 lg:px-10">
      <p className="font-serif text-[13vw] leading-none tracking-tight text-white/90 lg:text-[9.5rem]">Ocenia Trust</p>
      <div className="mt-14 flex flex-col gap-6 border-t border-white/15 pt-8 text-sm md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© 2026 {FIRM.name} · N° {FIRM.reg} · {t.footer.rights}</p>
        <p>Moroni (Grande Comore) · Mutsamudu (Anjouan) · Fomboni (Mohéli) — Union des Comores</p>
        <button data-testid="footer-back-to-top" onClick={() => go("hero")} className="inline-flex items-center gap-2 text-white hover:text-slate-300 transition-colors">
          {t.footer.top} <ArrowUp size={14} />
        </button>
      </div>
    </div>
  </footer>
);
